// src/lib/logger.tss
type Level = "debug" | "info" | "warn" | "error";

const isServer = typeof window === "undefined";
const levelRank: Record<Level, number> = { debug: 0, info: 1, warn: 2, error: 3 };

function getEnv(name: string, fallback = "") {
  try {
    // client: NEXT_PUBLIC_ / server: そのまま
    // どちらでも動くように両方見る
    // @ts-ignore
    return process.env[name] ?? process.env["NEXT_PUBLIC_" + name] ?? fallback;
  } catch {
    return fallback;
  }
}

// 例: NEXT_PUBLIC_LOG_NS="record,planBanner" / NEXT_PUBLIC_LOG_LEVEL="info"
const nsAllow = (getEnv("LOG_NS", "") || getEnv("NEXT_PUBLIC_LOG_NS", ""))
  .split(",")
  .map(s => s.trim())
  .filter(Boolean);
const currentLevel = (getEnv("LOG_LEVEL", "info") || getEnv("NEXT_PUBLIC_LOG_LEVEL", "info")) as Level;

function canLog(ns: string, level: Level) {
  const levelOk = levelRank[level] >= (levelRank[currentLevel] ?? 1);
  // serverは allow未設定でもOFF（=静か）にしておく。必要時だけLOG_NSで開ける運用。
  const nsOk = nsAllow.length === 0 ? false : nsAllow.includes(ns);
  return levelOk && nsOk && !isServer; // clientの騒音を抑えるのが目的
}

export function createLogger(ns: string) {
  return {
    debug: (...args: any[]) => { if (canLog(ns, "debug")) console.debug(`[${ns}]`, ...args); },
    info:  (...args: any[]) => { if (canLog(ns, "info"))  console.info(`[${ns}]`, ...args); },
    warn:  (...args: any[]) => { if (canLog(ns, "warn"))  console.warn(`[${ns}]`, ...args); },
    error: (...args: any[]) => { if (canLog(ns, "error")) console.error(`[${ns}]`, ...args); },
  };
}
